import { render, staticRenderFns } from "./scrollView.vue?vue&type=template&id=49458677&scoped=true&"
import script from "./scrollView.vue?vue&type=script&lang=js&"
export * from "./scrollView.vue?vue&type=script&lang=js&"
import style0 from "./scrollView.vue?vue&type=style&index=0&id=49458677&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49458677",
  null
  
)

export default component.exports